<app-items-table
  [orderItemsFormCustomDate]="orderItemsFormCustomDate"
  [supportsSplitDelivery]="supportsSplitDelivery"
  [showStockQty]="showStockQty"
  [maxStoreCustomDate]="maxStoreCustomDate"
  [componentId]="componentId"
  [expandCollapse$]="expandCollapse$"
  (dateAdded)="dateAdded.emit($event)"
  (stockDateAdded)="stockDateAdded.emit($event)"
  (customDateCleared)="customDateCleared.emit($event)"
  (dateRemoved)="dateRemoved.emit($event)"
  (dateTimeChanged)="dateTimeChanged.emit($event)">
</app-items-table>
